import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-undo',
	templateUrl: './icon-undo.component.svg',
})
export class IconUndoComponent {}
